// src/js/components/search-drawer.js
var SearchDrawerMain = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      drawer: "[search-drawer-js]",
      drawerClose: "[drawer-close]",
      drawerOpener: "[toggle-search-drawer]",
      overlay: ".overlay-body--layer",
      input: ".search__input"
    };
    this.init();
  }
  init() {
    this.drawer = this.querySelector(this.selectors.drawer);
    this.drawerClose = this.querySelector(this.selectors.drawerClose);
    this.drawerOpener = document.querySelector(this.selectors.drawerOpener);
    this.overlay = this.querySelector(this.selectors.overlay);
    this.input = this.querySelector(this.selectors.input);
    this.overlay?.addEventListener("click", () => {
      this.toggleDrawer();
    });
    this.drawerOpener?.addEventListener("click", () => {
      this.toggleDrawer();
    });
    this.drawerClose?.addEventListener("click", () => {
      this.toggleDrawer();
    });
  }
  toggleDrawer() {
    if (!this.drawer) {
      return;
    }
    if (this.drawer.classList.contains("active")) {
      this.drawer.classList.remove("active");
      this.overlay.classList.remove("active");
      document.documentElement.style.overflow = "";
    } else {
      this.drawer.classList.add("active");
      this.overlay.classList.add("active");
      this.input.focus();
      document.documentElement.style.overflow = "hidden";
    }
  }
};
customElements.define("search-drawer-main", SearchDrawerMain);
